/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { IDashboardCard } from 'src/app/model/dashboard/dashboard-card';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent {

  @Input() public dashboardCard: IDashboardCard;
  @Input() public isPrimary: boolean = true;
  @Input() public isDisabledController: boolean;
}
